// src/App.js
import React, { useLayoutEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import { usePageTracking } from "./components/usePageTracking";
import PageLayout from "./components/PageLayout";

import TarotApp from "./TarotApp";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Disclaimer from "./pages/Disclaimer";
import Privacy from "./pages/Privacy";
import EmotionPage from "./pages/EmotionPage";
import WhatsTarot from "./pages/WhatsTarot";
import MajorArcana from "./pages/MajorArcana";
import Wands from "./pages/Wands";
import Cups from "./pages/Cups";
import Swords from "./pages/Swords";
import Pentacles from "./pages/Pentacles";
import TarotCards from "./pages/TarotCards";
import TarotCardPage from "./pages/TarotCardPage";
import SearchResults from "./pages/SearchResults";
import FateFriday from "./pages/FateFriday";
import FullMoon from "./pages/FullMoon";
import YesNoTarot from "./pages/YesNoTarot";
import Readmycard from "./pages/Readmycard";
import Tarotscope from "./pages/Tarotscope";
import TarotscopeSign from "./pages/TarotscopeSign";

function ScrollManager() {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.lang =
      location.pathname === "/es" || location.pathname.startsWith("/es/") ? "es" : "en";

    const html = document.documentElement;
    const previousBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";

    if (location.hash) {
      const target = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (target) {
        target.scrollIntoView({ block: "start" });
      } else {
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
    }

    requestAnimationFrame(() => {
      html.style.scrollBehavior = previousBehavior || "";
    });
  }, [location.pathname, location.hash]);

  return null;
}

export default function App() {
  usePageTracking();

  return (
    <PageLayout>
      <ScrollManager />

      <Routes>
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/what-is-tarot-cards-complete-guide" element={<WhatsTarot />} />
        <Route path="/fate-friday" element={<FateFriday />} />
        <Route path="/full-moon" element={<FullMoon />} />
        <Route path="/tarotscope" element={<Tarotscope />} />
        <Route path="/tarotscope/:slug" element={<TarotscopeSign />} />
        <Route path="/readmycard" element={<Readmycard />} />

        <Route path="/tarot-for-:emotionSlug/" element={<EmotionPage />} />
        <Route path="/emotions/:emotionSlug" element={<EmotionPage />} />

        <Route path="/tarot-cards" element={<TarotCards />} />
        <Route path="/tarot-card/:cardSlug" element={<TarotCardPage />} />
        <Route path="/tarot/major-arcana" element={<MajorArcana />} />
        <Route path="/tarot/wands" element={<Wands />} />
        <Route path="/tarot/cups" element={<Cups />} />
        <Route path="/tarot/swords" element={<Swords />} />
        <Route path="/tarot/pentacles" element={<Pentacles />} />
        <Route path="/tarot/major-arcana-tarot-suit-cards-meaning" element={<Navigate to="/tarot/major-arcana" replace />} />
        <Route path="/tarot/wands-tarot-suit-cards-meaning" element={<Navigate to="/tarot/wands" replace />} />
        <Route path="/tarot/cups-tarot-suit-cards-meaning" element={<Navigate to="/tarot/cups" replace />} />
        <Route path="/tarot/swords-tarot-suit-cards-meaning" element={<Navigate to="/tarot/swords" replace />} />
        <Route path="/tarot/pentacles-tarot-suit-cards-meaning" element={<Navigate to="/tarot/pentacles" replace />} />

        <Route path="/yes-no-tarot" element={<YesNoTarot />} />
        <Route path="/" element={<TarotApp />} />
        <Route path="/search" element={<SearchResults />} />

        <Route path="/es/about" element={<About />} />
        <Route path="/es/contact" element={<Contact />} />
        <Route path="/es/disclaimer" element={<Disclaimer />} />
        <Route path="/es/privacy" element={<Privacy />} />
        <Route path="/es/what-is-tarot-cards-complete-guide" element={<WhatsTarot />} />
        <Route path="/es/fate-friday" element={<FateFriday />} />
        <Route path="/es/full-moon" element={<FullMoon />} />
        <Route path="/es/tarotscope" element={<Tarotscope />} />
        <Route path="/es/tarotscope/:slug" element={<TarotscopeSign />} />
        <Route path="/es/readmycard" element={<Readmycard />} />

        <Route path="/es/tarot-for-:emotionSlug/" element={<EmotionPage />} />
        <Route path="/es/emotions/:emotionSlug" element={<EmotionPage />} />

        <Route path="/es/tarot-cards" element={<TarotCards />} />
        <Route path="/es/tarot-card/:cardSlug" element={<TarotCardPage />} />
        <Route path="/es/tarot/major-arcana" element={<MajorArcana />} />
        <Route path="/es/tarot/wands" element={<Wands />} />
        <Route path="/es/tarot/cups" element={<Cups />} />
        <Route path="/es/tarot/swords" element={<Swords />} />
        <Route path="/es/tarot/pentacles" element={<Pentacles />} />
        <Route path="/es/tarot/major-arcana-tarot-suit-cards-meaning" element={<Navigate to="/es/tarot/major-arcana" replace />} />
        <Route path="/es/tarot/wands-tarot-suit-cards-meaning" element={<Navigate to="/es/tarot/wands" replace />} />
        <Route path="/es/tarot/cups-tarot-suit-cards-meaning" element={<Navigate to="/es/tarot/cups" replace />} />
        <Route path="/es/tarot/swords-tarot-suit-cards-meaning" element={<Navigate to="/es/tarot/swords" replace />} />
        <Route path="/es/tarot/pentacles-tarot-suit-cards-meaning" element={<Navigate to="/es/tarot/pentacles" replace />} />

        <Route path="/es/yes-no-tarot" element={<YesNoTarot />} />
        <Route path="/es" element={<TarotApp />} />
        <Route path="/es/search" element={<SearchResults />} />
      </Routes>
    </PageLayout>
  );
}

